import React from 'react';
import { Markdown } from '../../General/Markdown';

interface Props {
    messages: string[];
}

const Messages:React.FC<Props> = ({ messages }) => {
    if (messages.length === 0) {
        return null;
    }

    return (
        <div className="interest-message-wrapper">
            <h6>Bepalingen</h6>
            <p>Op deze tarieven zijn de volgende bepalingen van toepassing:</p>
            {messages.map((message, index) => (
                <div className="interest-message" key={index}>
                    <Markdown text={message} />
                </div>
            ))}
        </div>
    );
}

export default Messages;
